import * as React from "react"
import {
    Box,
    Button,
    FormControlLabel,
    Grid,
    makeStyles,
    Switch,
    TextField,
    Typography,
    useTheme
} from "@material-ui/core";
import Widget from "../../../components/BetterWidget";
import {useEffect, useState} from "react";

const useStyle = makeStyles(theme => {
    return {
        root:{
            padding: theme.spacing(2),
            width: "100%",
            "& h3":{
                color: theme.palette.text.disabled,
                margin: theme.spacing(1, 0),
            },
            "& > div":{
                width:"100%"
            }
        }
    }
})

export default function ({device, setMonitored, setOfflineAlert}){

    const classes = useStyle(useTheme())
    const [hours, setHours] = useState(device.offline_alert.toString());

    useEffect(() => {
        if (device.offline_alert){
            setHours(device.offline_alert.toString())
        }
    }, [device.offline_alert]);

    const hoursAsInt = hours && parseInt(hours) || 0

    return <Box className={classes.root}>
        <Typography variant="h3">Monitoring Settings</Typography>
        <Widget>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Switch checked={device.monitored} onChange={(_, show) => {
                            setMonitored(show)
                        }}/>}
                        label="Monitored"
                        labelPlacement="start"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={8} lg={9} xl={10}>
                    <TextField
                        label="Alert when offline for more than ( hours )"
                        value={hours}
                        onChange={e => setHours(e.target.value.replaceAll(/\D+/g, ''))}
                        onBlur={() => {
                            if (!hours.length){
                                setHours(device.offline_alert.toString());
                            }
                        }}
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
                <Grid container item xs={12} sm={6} md={4} lg={3} xl={2} alignItems="center">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setOfflineAlert(hoursAsInt)}
                        disabled={device.offline_alert === hoursAsInt || !hours.length}
                        size="large"
                    >
                        Apply
                    </Button>
                </Grid>
            </Grid>
        </Widget>
    </Box>
}
